import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import ApplicationLayout from "./ApplicationLayout";
import { FC, lazy, useMemo } from "react";
import { registerGlobal403Handler } from "am-tax-fe-core";

const DocumentAnalysisPage = lazy(() => import("./DocumentAnalysisPage/DocumentAnalysisPage"));
const ApplicationPage = lazy(() => import("./UseCasePage/ApplicationPage").then(m => ({ default: m.ApplicationPage })));
const MarkdownConverterPage = lazy(() => import("./MarkdownConverterPage/MarkdownConverterPage").then(m => ({ default: m.MarkdownConverterPage })));
const OcrPlaygroundPage = lazy(() => import("./OcrPlaygroundPage").then(m => ({ default: m.OcrPlaygroundPage })));
const GenericChatPage = lazy(() => import("./GenericChatPage").then(m => ({ default: m.GenericChatPage })));
const AdminDashboardPage = lazy(() => import("./AdminDashboardPage").then(m => ({ default: m.AdminDashboardPage })));
const ApiKeyDisabledPage = lazy(() => import("./ApiKeyDisabledPage").then(m => ({ default: m.ApiKeyDisabledPage })));
const UnauthorizedPage = lazy(() => import("./UnauthorizedPage").then(m => ({ default: m.UnauthorizedPage })));
const NotFoundPage = lazy(() => import("./NotFoundPage").then(m => ({ default: m.NotFoundPage })));

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<ApplicationLayout />}>
            <Route index element={<ApplicationPage />} />
            <Route path="application" element={<ApplicationPage />} />
            <Route path="projects/:projectId" element={<DocumentAnalysisPage />} />
            <Route path="documents/:documentId" element={<DocumentAnalysisPage />} />
            <Route path="markdown-converter" element={<MarkdownConverterPage />} />
            <Route path="ocr-playground" element={<OcrPlaygroundPage />} />
            <Route path="chat" element={<GenericChatPage />} />
            <Route path="admin" element={<AdminDashboardPage />} />
            <Route path="api-key-disabled" element={<ApiKeyDisabledPage />} />
            <Route path="Unauthorized" element={<UnauthorizedPage />} />
            <Route path="404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Route>,
    ),
);

export const PageRoutes: FC = () => {
    useMemo(() => {
        registerGlobal403Handler(() => {
            router.navigate("/unauthorized");
        });
    }, []);

    return <RouterProvider router={router} />;
};
